
<footer class="all-transport-list__footer">
  <ci-button
    class="footer__close-button"
    class-name="ci-btn-primary-s-outlined"
    [arial-label]="'Cerrar detalles de transporte' | translate"
    (click)="handleCloseOnClick()"
  >
    {{ 'Cerrar' | translate }}
  </ci-button>
</footer>